var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCompanies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "26pt",
    height: "26pt",
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.555 19.254l.101-12.508a.897.897 0 00-.894-.894h-6.27v7.644h1.79a.878.878 0 01.894.863v4.895h-.895v-4.871h-2.687V7.836h-6.27a.897.897 0 00-.894.883v10.535H3.64v.894h18.72v-.894zM8.563 17.12h-.891v-.894h.89zm0-3.18h-.891v-.89h.89zm0-2.976h-.891v-.895h.89zm2.69 7.05h-.898v-1.788h.899zm0-4.07h-.898v-.894h.899zm0-2.98h-.898v-.895h.899zm2.528 6.156h-.894v-.894h.894zm2.598-4.766h-.899v-.894h.899zm0-3.574h-.899v-.894h.899zm2.46 9.235h-.898v-1.79h.895zm.231-5.66h-.902v-.895h.895zm0-3.575h-.902v-.894h.895zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCompanies);
export default __webpack_public_path__ + "static/media/icon-companies.a1b66ae17051f6d7292d8e0b32c07a6b.svg";
export { ForwardRef as ReactComponent };